export type Direction = 'up' | 'down';

export const startVerticalScroll = (
    ref: React.RefObject<HTMLDivElement>,
    direction: Direction,
    intervalRef: React.MutableRefObject<NodeJS.Timeout | null>,
    scrollAmount: number = 10,
    scrollDelay: number = 10
) => {
    if (intervalRef.current) return;

    intervalRef.current = setInterval(() => {
        if (ref.current) {
            ref.current.scrollBy({
                top: direction === 'up' ? -scrollAmount : scrollAmount,
                behavior: 'auto',
            });
        }
    }, scrollDelay);
};

export const stopVerticalScroll = (
    intervalRef: React.MutableRefObject<NodeJS.Timeout | null>
) => {
    if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
    }
};
